import {EvalEnv} from '@packages/systems/wfdl';
import {DYNAMO_VARIABLE} from '@packages/systems/dynamo/wfdl';
import {createDynamoEnvProxy} from './createDynamoEnvProxy';
import {EMPTY_DYNAMO_ENV} from './emptyDynamoEnv';
export {EMPTY_DYNAMO_ENV} from './emptyDynamoEnv';

import type {AdaptedData} from '../types';

export function setDynamoEnv(
  env: EvalEnv.EvalEnvType,
  data: AdaptedData,
  dynContextData: AdaptedData
): EvalEnv.EvalEnvType {
  const proxiedData = createDynamoEnvProxy(data, dynContextData);

  if (proxiedData === null) {
    // element doesn't have a valid Dynamo env value,
    // so we insert an empty Dynamo env object
    return setEmptyDynamoEnv(env);
  }

  return EvalEnv.insertValue(env, DYNAMO_VARIABLE, proxiedData);
}

export function setEmptyDynamoEnv(
  env: EvalEnv.EvalEnvType
): EvalEnv.EvalEnvType {
  return EvalEnv.insertValue(env, DYNAMO_VARIABLE, EMPTY_DYNAMO_ENV);
}
